import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, of } from 'rxjs';
import { environment } from '@environments/environment';
import { IAdresseSearchGouvResponse, IAdresseSearchResponse } from '@core-lib/models/adresse.model';

@Injectable({
	providedIn: 'root'
})
export class AdresseService {
	private readonly apiUrl = 'https://api-adresse.data.gouv.fr/search/';

	constructor(private http: HttpClient) {}

	searchGouv(query: string): Observable<IAdresseSearchGouvResponse> {
		const url = `${this.apiUrl}?q=${query}&limit=15`;
		return this.http.get<IAdresseSearchGouvResponse>(url);
	}

	searchApi(query: string): Observable<IAdresseSearchResponse[]> {
		// Inutile de lancer une recherche avec un input trop court
		if (query.length < 5) {
			return of([]);
		}

		const url = `${environment.apiUrl}/Adresse?query=${query}&limit=15`;
		return this.http.get<IAdresseSearchResponse[]>(url);
	}
}

